import { QueryCellInfoEventArgs, RowDataBoundEventArgs } from '@syncfusion/ej2-react-grids';

export interface RowStylingRule {
    condition: (data: any) => boolean;
    style: {
        light: string;
        dark: string;
    };
}

export const applyRowStyling = (
    args: RowDataBoundEventArgs,
    rules: RowStylingRule[],
    theme: 'light' | 'dark' = 'light'
): void => {
    if (!args.data || !args.row) return;

    const data = args.data as any;
    const row = args.row as HTMLElement;

    if (row.classList.contains('custom-row-styled')) {
        row.style.removeProperty('background-color');
        row.style.removeProperty('color');
        row.querySelectorAll('td').forEach(cell => {
            (cell as HTMLElement).style.removeProperty('background-color');
            (cell as HTMLElement).style.removeProperty('color');
        });

        row.classList.remove('custom-row-styled');
    }

    for (const rule of rules) {
        if (rule.condition(data)) {
            const styleString = rule.style[theme];

            styleString.split(';').forEach(s => {
                const colonIdx = s.indexOf(':');
                if (colonIdx === -1) return;

                const prop = s.slice(0, colonIdx).trim();
                const val = s.slice(colonIdx + 1).trim().replace(/!important\s*$/, '').trim();

                if (prop && val) {
                    row.style.setProperty(prop, val, 'important');
                    row.querySelectorAll('td').forEach(cell => {
                    (cell as HTMLElement).style.setProperty(prop, val, 'important');
                    });
                }
            });
            row.classList.add('custom-row-styled');
        }
    }
};

export const booleanGrayRule = (field: string, expectedValue = true): RowStylingRule => ({
    condition: (data) => {
        const value = data[field] ?? data.taskData?.[field];
        return value === expectedValue;
    },
    style: {
        light: 'background-color: #d8dde5 !important; color: #6c737d !important',
        dark:  'background-color: #3c4756 !important; color: #a4acb8 !important',
    },
});

/* export const rowGrayRule = (priorityCode: string): RowStylingRule => ({
    condition: (data) => {
        const code = data.priority_code ?? data.taskData?.priority_code;
        //console.log('rowGrayRule check:', code, '===', priorityCode, '->', code?.trim() === priorityCode);
        return code?.trim() === priorityCode;
    },
    style: {
        light: 'background-color: #d8dde5 !important; color: #6c737d !important',
        dark:  'background-color: #3c4756 !important; color: #a4acb8 !important',
    },
}); */
